export default "__VITE_ASSET__eb777e95__"